import styled from 'styled-components';
import { ReactComponent as LogoSvg } from '../dashboard/resources/logo.svg';
import { ReactComponent as LogoCompactSvg } from '../dashboard/resources/logoCompact.svg';

export const Logo = styled(LogoSvg)`
    user-select: none;
    display: inline-block;
    fill: var(--color-primary);
    flex-shrink: 0;
    stroke: none;
    font-size: inherit;
`;

export const LogoCompact = styled(LogoCompactSvg)`
    user-select: none;
    display: inline-block;
    fill: var(--color-primary);
    flex-shrink: 0;
    stroke: none;
    font-size: inherit;
`;
